// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav.XpbLl4OyE87r6fhSd5RD {
  margin: 0 !important;
  border: none !important;
}

.BrvtzH2ee9RdG925_0Qv {
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 0.5rem;
}

.fkMHtYzxtT7qf2hRMYbH {
  font-weight: 500;
  font-size: 18px;
  line-height: 23px;
  width: 50%;
}

.vD3WFBfxoM5KEk_EG8cI {
  font-weight: 400;
  font-size: 14px;
}

#WIkP6fHDOkbebQi0obOf button {
  align-items: center;
  box-shadow: 0 0 0 1pt #333333;
  display: flex;
  border: none;
  border-radius: 2px;
  font-size: 16px;
  line-height: 19px;
  height: fit-content;
  letter-spacing: 0.8px;
  padding: 6px 10px 6px 10px;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/modules/samples/components/topheader/topheader.module.scss"],"names":[],"mappings":"AACA;EACE,oBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;EACA,WAAA;AAAF;;AAGA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;AAAF;;AAGA;EACE,gBAAA;EACA,eAAA;AAAF;;AAIE;EACE,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,0BAAA;AADJ","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\nnav.nav_breadcrumb {\n  margin: 0 !important;\n  border: none !important;\n}\n\n.container {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  gap: 0.5rem;\n}\n\n.header_title {\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 23px;\n  width: 50%;\n}\n\n.header_subtitle {\n  font-weight: 400;\n  font-size: 14px;\n}\n\n#action_buttons {\n  & button {\n    align-items: center;\n    box-shadow: 0 0 0 1pt $dark-gray;\n    display: flex;\n    border: none;\n    border-radius: 2px;\n    font-size: 16px;\n    line-height: 19px;\n    height: fit-content;\n    letter-spacing: 0.8px;\n    padding: 6px 10px 6px 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nav_breadcrumb": `XpbLl4OyE87r6fhSd5RD`,
	"container": `BrvtzH2ee9RdG925_0Qv`,
	"header_title": `fkMHtYzxtT7qf2hRMYbH`,
	"header_subtitle": `vD3WFBfxoM5KEk_EG8cI`,
	"action_buttons": `WIkP6fHDOkbebQi0obOf`
};
export default ___CSS_LOADER_EXPORT___;
